import _extends from "@babel/runtime-corejs3/helpers/extends";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find";
import React, { useContext, useEffect } from 'react';
import classnames from 'classnames';
import parse from 'date-fns/parse';
import ConfigContext from '../config-provider/ConfigContext';
import { useMergedState, useOnClickOutside } from '../_utils/hooks';
import { getCompProps } from '../_utils';
import Context from './context';
import Panel from './date-panel';
import InputDate from './single/input-date';
import { getDefaultFormat, getDataOrAriaProps, getInternalNextMode, generateUnits } from './utils';
import useValueTexts from './hooks/use-value-texts';
import useHoverValue from './hooks/use-hover-value';
import { formatDate, getHours, getLowerBoundTime, getMinutes, getSeconds, isEqual, isValid, newDate, parseDate, setTime } from './utils/date-fns';
import useTextValueMapping from './hooks/use-text-value-mapping';
import { getCompLangMsg } from '../locale';
import getExtraFooter from './utils/get-extra-footer';
import getRanges from './utils/get-ranges';
import usePopper from '../_utils/usePopper';

function DatePicker(props) {
  var customPrefixcls = props.prefixCls;

  var _useContext = useContext(ConfigContext),
      getPrefixCls = _useContext.getPrefixCls,
      prefixCls = _useContext.prefixCls,
      userDefaultProps = _useContext.compDefaultProps,
      globalLocale = _useContext.locale;

  var datePickerProps = getCompProps('DatePicker', userDefaultProps, props);
  var datePickerPrefixCls = getPrefixCls(prefixCls, 'date-picker', customPrefixcls);
  var id = datePickerProps.id,
      style = datePickerProps.style,
      className = datePickerProps.className,
      dropdownClassName = datePickerProps.dropdownClassName,
      popupStyle = datePickerProps.popupStyle,
      locale = datePickerProps.locale,
      inputReadOnly = datePickerProps.inputReadOnly,
      allowClear = datePickerProps.allowClear,
      autoFocus = datePickerProps.autoFocus,
      _datePickerProps$pick = datePickerProps.picker,
      picker = _datePickerProps$pick === void 0 ? 'date' : _datePickerProps$pick,
      mode = datePickerProps.mode,
      format = datePickerProps.format,
      value = datePickerProps.value,
      defaultValue = datePickerProps.defaultValue,
      defaultPickerValue = datePickerProps.defaultPickerValue,
      open = datePickerProps.open,
      defaultOpen = datePickerProps.defaultOpen,
      suffixIcon = datePickerProps.suffixIcon,
      clearIcon = datePickerProps.clearIcon,
      disabled = datePickerProps.disabled,
      placeholder = datePickerProps.placeholder,
      borderType = datePickerProps.borderType,
      size = datePickerProps.size,
      showToday = datePickerProps.showToday,
      showTime = datePickerProps.showTime,
      showNow = datePickerProps.showNow,
      use12Hours = datePickerProps.use12Hours,
      components = datePickerProps.components,
      _datePickerProps$hour = datePickerProps.hourStep,
      hourStep = _datePickerProps$hour === void 0 ? 1 : _datePickerProps$hour,
      _datePickerProps$minu = datePickerProps.minuteStep,
      minuteStep = _datePickerProps$minu === void 0 ? 1 : _datePickerProps$minu,
      _datePickerProps$seco = datePickerProps.secondStep,
      secondStep = _datePickerProps$seco === void 0 ? 1 : _datePickerProps$seco,
      disabledDate = datePickerProps.disabledDate,
      disabledHours = datePickerProps.disabledHours,
      disabledMinutes = datePickerProps.disabledMinutes,
      disabledSeconds = datePickerProps.disabledSeconds,
      panelRender = datePickerProps.panelRender,
      renderExtraFooter = datePickerProps.renderExtraFooter,
      onChange = datePickerProps.onChange,
      onSelect = datePickerProps.onSelect,
      onOpenChange = datePickerProps.onOpenChange,
      onFocus = datePickerProps.onFocus,
      onBlur = datePickerProps.onBlur,
      onMouseDown = datePickerProps.onMouseDown,
      onMouseUp = datePickerProps.onMouseUp,
      onMouseEnter = datePickerProps.onMouseEnter,
      onMouseLeave = datePickerProps.onMouseLeave,
      onContextMenu = datePickerProps.onContextMenu,
      onClick = datePickerProps.onClick,
      _onOk = datePickerProps.onOk; // ref

  var panelDivRef = React.useRef(null);
  var inputDivRef = React.useRef(null);
  var popperRef = React.useRef(null);
  var inputRef = React.useRef(null);
  var isHourStepValid = 24 % hourStep === 0;
  var isMinuteStepValid = 60 % minuteStep === 0;
  var isSecondStepValid = 60 % secondStep === 0; // const hours = generateUnits(0, 23, hourStep, disabledHours && disabledHours())
  // const minutes = generateUnits(0, 59, minuteStep, disabledMinutes && disabledMinutes(originHour))
  // const seconds = generateUnits(0, 59, secondStep, disabledSeconds && disabledSeconds(originHour, minute))

  var needConfirmButton = picker === 'date' && !!showTime || picker === 'time';
  var datePickerLang = locale ? getCompLangMsg({
    componentName: 'DatePicker'
  }, function (_componentName, label) {
    return locale[label];
  }) : globalLocale.getCompLangMsg({
    componentName: 'DatePicker'
  }); // console.log(_format)
  // 原始数据

  var _useMergedState = useMergedState(null, {
    value: value,
    defaultValue: defaultValue
  }),
      _useMergedState2 = _slicedToArray(_useMergedState, 2),
      dateValue = _useMergedState2[0],
      setDateValue = _useMergedState2[1]; // 选中的数据


  var _React$useState = React.useState(dateValue),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      selectedValue = _React$useState2[0],
      setSelectedValue = _React$useState2[1];

  var hours;
  var minutes;
  var seconds;
  var originHour;
  var minute;
  var second;
  var disabledTimePanel = false;

  if (picker === 'time' || picker === 'date' && showTime) {
    originHour = selectedValue ? getHours(selectedValue) : -1;
    minute = selectedValue ? getMinutes(selectedValue) : -1;
    second = selectedValue ? getSeconds(selectedValue) : -1;
    hours = generateUnits(0, 23, hourStep, disabledHours && disabledHours());
    minutes = generateUnits(0, 59, minuteStep, disabledMinutes && disabledMinutes(originHour));
    seconds = generateUnits(0, 59, secondStep, disabledSeconds && disabledSeconds(originHour, minute));

    if (hours && !_findInstanceProperty(hours).call(hours, function (n) {
      return !n.disabled;
    }) || minutes && !_findInstanceProperty(minutes).call(minutes, function (n) {
      return !n.disabled;
    }) || seconds && !_findInstanceProperty(seconds).call(seconds, function (n) {
      return !n.disabled;
    })) {
      disabledTimePanel = true;
    }
  }

  var _format = getDefaultFormat(format, picker, showTime && !disabledTimePanel, use12Hours); // 面板展示日期


  var _useMergedState3 = useMergedState(null, {
    // value: pickerValue,
    defaultValue: defaultPickerValue || dateValue,
    postState: function postState(date) {
      return date || newDate();
    }
  }),
      _useMergedState4 = _slicedToArray(_useMergedState3, 2),
      viewDate = _useMergedState4[0],
      setViewDate = _useMergedState4[1]; // text


  var valueText = useValueTexts(selectedValue, {
    format: _format
  }); // input 展示

  var _useTextValueMapping = useTextValueMapping({
    valueText: valueText,
    onTextChange: function onTextChange(newText) {
      // if (typeof _format !== 'function') {
      var inputDate;

      if (picker !== 'year') {
        inputDate = parseDate(newText, _format);
      } else {
        var year = parse(newText, _format, newDate());
        inputDate = isValid(year) ? year : null;
      }

      if (inputDate && (!disabledDate || !disabledDate(inputDate))) {
        setSelectedValue(inputDate);
        setViewDate(inputDate);
      }
    }
  }),
      _useTextValueMapping2 = _slicedToArray(_useTextValueMapping, 3),
      text = _useTextValueMapping2[0],
      triggerTextChange = _useTextValueMapping2[1],
      resetText = _useTextValueMapping2[2];

  var _useHoverValue = useHoverValue(text, {
    format: _format
  }),
      _useHoverValue2 = _slicedToArray(_useHoverValue, 3),
      hoverValue = _useHoverValue2[0],
      onEnter = _useHoverValue2[1],
      onLeave = _useHoverValue2[2];

  var _useMergedState5 = useMergedState(false, {
    value: open,
    defaultValue: defaultOpen,
    postState: function postState(postOpen) {
      return disabled ? false : postOpen;
    },
    onChange: function onChange(newOpen) {
      if (onOpenChange) {
        onOpenChange(newOpen);
      } // if (!newOpen && operationRef.current && operationRef.current.onClose) {
      //   operationRef.current.onClose()
      // }

    }
  }),
      _useMergedState6 = _slicedToArray(_useMergedState5, 2),
      openValue = _useMergedState6[0],
      triggerInnerOpen = _useMergedState6[1]; // Save panel is changed from which panel


  var _useMergedState7 = useMergedState(function () {
    if (picker === 'time') {
      return 'time';
    }

    return getInternalNextMode('date', picker);
  }, {
    value: mode
  }),
      _useMergedState8 = _slicedToArray(_useMergedState7, 2),
      mergedMode = _useMergedState8[0],
      setInnerMode = _useMergedState8[1];

  useEffect(function () {
    setInnerMode(picker);
  }, [picker]);
  useEffect(function () {
    if (!openValue) {
      setSelectedValue(dateValue);

      if (valueText === '') {
        triggerTextChange('');
      } else if (valueText !== text) {
        resetText();
      }
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [openValue, valueText]);
  useEffect(function () {
    if (!openValue) {
      resetText();
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [picker]);
  useEffect(function () {
    setSelectedValue(dateValue);
  }, [dateValue]);
  useOnClickOutside([popperRef, inputDivRef], function () {
    setViewDate(selectedValue || newDate());
    triggerOpen(false);
  });

  var triggerChange = function triggerChange(newValue) {
    setSelectedValue(newValue);
    setDateValue(newValue);

    if (onSelect) {
      onSelect(newValue);
    }

    if (onChange && !isEqual(dateValue, newValue)) {
      onChange(newValue, newValue ? formatDate(newValue, _format) : '');
    }
  };

  var triggerOpen = function triggerOpen(newOpen) {
    if (disabled && newOpen) {
      return;
    }

    triggerInnerOpen(newOpen);
  };

  var onContextSelect = function onContextSelect(date, type) {
    if (type === 'submit' || type !== 'key' && !needConfirmButton) {
      setViewDate(date);
      triggerChange(date);
      triggerOpen(false);
    } else {
      setViewDate(date);
      triggerChange(date);
    }
  };

  var onNow = function onNow() {
    var now = newDate();
    var lowerBoundTime = getLowerBoundTime(getHours(now), getMinutes(now), getSeconds(now), isHourStepValid ? hourStep : 1, isMinuteStepValid ? minuteStep : 1, isSecondStepValid ? secondStep : 1);
    var adjustedNow = setTime(now, {
      hour: lowerBoundTime[0],
      minute: lowerBoundTime[1],
      second: lowerBoundTime[2]
    });

    if (disabledDate && disabledDate(adjustedNow) || disabledTimePanel) {
      return;
    }

    onContextSelect(adjustedNow, 'submit');
  };

  var extraFooter = getExtraFooter(datePickerPrefixCls, mergedMode, renderExtraFooter);
  var rangesNode = getRanges({
    prefixCls: datePickerPrefixCls,
    components: components,
    needConfirmButton: needConfirmButton,
    okDisabled: !selectedValue || disabledDate && disabledDate(selectedValue),
    locale: datePickerLang,
    showNow: showNow,
    onNow: needConfirmButton && onNow,
    onOk: function onOk() {
      if (selectedValue) {
        onContextSelect(selectedValue, 'submit');

        if (_onOk) {
          _onOk(selectedValue);
        }
      }
    }
  });
  var todayNode;

  if (showToday && mergedMode === 'date' && picker === 'date' && !showTime) {
    var now = newDate();
    var todayCls = "".concat(datePickerPrefixCls, "-today-btn");

    var _disabled = disabledDate && disabledDate(now);

    todayNode = /*#__PURE__*/React.createElement("div", {
      className: classnames(todayCls, _disabled && "".concat(datePickerPrefixCls, "-btn-disabled")),
      "aria-disabled": _disabled,
      onClick: function onClick() {
        if (!_disabled) {
          onContextSelect(now, 'mouse');
        }
      }
    }, datePickerLang.today);
  }

  var panelProps = _extends(_extends({}, datePickerProps), {
    format: _format,
    onChange: setSelectedValue
  }); // 渲染日期选择表盘


  function renderPanel() {
    var panelNode = /*#__PURE__*/React.createElement(Panel, _extends({}, panelProps));

    if (panelRender) {
      panelNode = panelRender(panelNode);
    }

    return /*#__PURE__*/React.createElement(Context.Provider, {
      value: {
        hours: hours,
        minutes: minutes,
        seconds: seconds,
        originHour: originHour,
        minute: minute,
        second: second,
        disabledTimePanel: disabledTimePanel,
        prefixCls: datePickerPrefixCls,
        dateValue: selectedValue,
        viewDate: viewDate,
        open: openValue,
        locale: datePickerLang,
        onSelect: onContextSelect,
        setViewDate: setViewDate,
        onDateMouseEnter: onEnter,
        onDateMouseLeave: onLeave
      }
    }, panelNode, extraFooter || rangesNode || todayNode ? /*#__PURE__*/React.createElement("div", {
      className: "".concat(datePickerPrefixCls, "-footer")
    }, extraFooter, rangesNode, todayNode) : null);
  }

  var inputProps = {
    inputRef: inputRef,
    panelDivRef: panelDivRef,
    id: id,
    autoFocus: autoFocus,
    allowClear: allowClear,
    className: className,
    borderType: borderType,
    disabled: disabled,
    hoverValue: hoverValue,
    picker: picker,
    placeholder: placeholder,
    style: style,
    size: size,
    text: text,
    needConfirmButton: needConfirmButton,
    suffixIcon: suffixIcon,
    clearIcon: clearIcon,
    dateValue: dateValue,
    selectedValue: selectedValue,
    format: _format,
    open: openValue,
    readOnly: inputReadOnly,
    prefixCls: datePickerPrefixCls,
    locale: datePickerLang,
    dataOrAriaProps: getDataOrAriaProps(datePickerProps),
    disabledDate: disabledDate,
    onFocus: onFocus,
    onBlur: onBlur,
    onMouseDown: onMouseDown,
    onMouseUp: onMouseUp,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    onContextMenu: onContextMenu,
    onClick: onClick,
    setSelectedValue: setSelectedValue,
    triggerTextChange: triggerTextChange,
    triggerOpen: triggerOpen,
    triggerChange: triggerChange,
    resetText: resetText
  };
  return usePopper( /*#__PURE__*/React.createElement(InputDate, _extends({
    ref: inputDivRef
  }, inputProps)), /*#__PURE__*/React.createElement("div", {
    ref: popperRef,
    onMouseDown: function onMouseDown(e) {
      e.preventDefault();
    }
  }, renderPanel()), {
    trigger: 'click',
    prefixCls: "".concat(datePickerPrefixCls, "-panel"),
    arrow: false,
    popperClassName: dropdownClassName,
    popperStyle: popupStyle,
    visible: openValue,
    placement: 'bottomLeft'
  });
}

export default DatePicker;